export default "__VITE_ASSET__VTnxC_so__"